// 退款相关翻译

export const refund = {
    title: '申请退款',
    orderInfo: '订单信息',
    conditionsTitle: '退款条件',
    reasonTitle: '退款原因（可选）',
    reasonPlaceholder: '请描述您申请退款的原因...',
    defaultReason: '用户申请退款',
    
    // 条件检查
    checkingConditions: '正在检查退款条件...',
    checkFailed: '检查退款条件失败',
    
    // 退款条件
    conditions: {
      isPaid: '订单已支付',
      withinTimeLimit: '在3天退款期限内',
      hasEnoughCredits: '积分余额充足',
      passRiskControl: '通过风控检查',
      noPendingRefund: '无正在处理的退款申请',
      creditsDetails: '当前：{{current}} 积分，需要：{{required}} 积分',
      riskDetails: '近期退款：{{count}}/2 次（30天内）'
    },
    
    // 退款说明
    notice: {
      title: '重要提醒：',
      creditDeduction: '退款通过后将立即扣除相应积分',
      processingTime: '退款处理需要3-5个工作日',
      irreversible: '退款申请提交后无法撤销'
    },
    
    // 按钮和状态
    confirm: '确认',
    submitting: '提交中...',
    cannotRefund: '无法退款',
    
    // 消息
    successMessage: '退款申请提交成功！金额：{{amount}}，退款ID：{{refundId}}',
    submitFailed: '提交退款申请失败'
  };
